import { AfterViewInit, Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { contientArabe } from './arabic-text';

/**
 * À poser sur un champ de formulaire (`ktAvertArabe`) : affiche, juste sous le champ, un avertissement orange
 * non bloquant dès que sa valeur contient de l'arabe (non imprimable dans le PDF).
 */
@Directive({ selector: '[ktAvertArabe]' })
export class AvertArabeDirective implements AfterViewInit, OnDestroy {
	private message: HTMLElement = null;
	private sub: Subscription;

	constructor(private el: ElementRef, private control: NgControl, private renderer: Renderer2) {}

	ngAfterViewInit(): void {
		this.maj(this.control.value);
		if (this.control.valueChanges) {
			this.sub = this.control.valueChanges.subscribe(v => this.maj(v));
		}
	}

	private maj(valeur: any): void {
		const arabe = contientArabe(valeur);
		if (arabe && !this.message) {
			const champ: HTMLElement = this.el.nativeElement.closest('mat-form-field') || this.el.nativeElement;
			this.message = this.renderer.createElement('small');
			this.renderer.addClass(this.message, 'champ-avert');
			this.renderer.appendChild(this.message, this.renderer.createText("⚠ Ce champ contient de l'arabe : les caractères arabes ne s'impriment pas dans le PDF. Vous pouvez enregistrer quand même."));
			this.renderer.insertBefore(champ.parentNode, this.message, champ.nextSibling);
		} else if (!arabe) {
			this.retire();
		}
	}

	private retire(): void {
		if (this.message && this.message.parentNode) {
			this.renderer.removeChild(this.message.parentNode, this.message);
		}
		this.message = null;
	}

	ngOnDestroy(): void {
		if (this.sub) {
			this.sub.unsubscribe();
		}
		this.retire();
	}
}
